(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach(question => {
    question.addEventListener('click', function() {
      const faqItem = this.parentElement;
      const faqAnswer = faqItem.querySelector('.faq-answer');
      const isActive = faqItem.classList.contains('active');

      // Close all other FAQ items
      document.querySelectorAll('.faq-item').forEach(item => {
        const answer = item.querySelector('.faq-answer');
        item.classList.remove('active');
        item.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
      });

      // Toggle current item with smooth animation
      if (!isActive) {
        faqItem.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
        faqAnswer.style.maxHeight = faqAnswer.scrollHeight + 'px';
      } else {
        faqAnswer.style.maxHeight = null;
      }
    });

    // Add keyboard support
    question.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const hamburger = document.querySelector('.hamburger');
  const menu = document.querySelector('.header__menu');
  const overlay = document.querySelector('.mobile-menu-overlay');
  const body = document.body;
  const header = document.querySelector('header');
  const spacer = document.querySelector('.header-spacer');

  function toggleMenu() {
    hamburger.classList.toggle('active');
    menu.classList.toggle('active');
    overlay.classList.toggle('active');

    // Prevent body scroll when menu is open
    if (menu.classList.contains('active')) {
      body.style.overflow = 'hidden';
      hamburger.setAttribute('aria-expanded', 'true');
    } else {
      body.style.overflow = '';
      hamburger.setAttribute('aria-expanded', 'false');
    }
  }

  function closeMenu() {
    hamburger.classList.remove('active');
    menu.classList.remove('active');
    overlay.classList.remove('active');
    body.style.overflow = '';
    hamburger.setAttribute('aria-expanded', 'false');

    // Close all dropdowns
    const dropdownItems = document.querySelectorAll('.menu-item--has-dropdown');
    dropdownItems.forEach(item => {
      item.classList.remove('active');
    });
  }

  // Toggle menu on hamburger click
  hamburger.addEventListener('click', toggleMenu);

  // Close menu on overlay click
  overlay.addEventListener('click', closeMenu);

  // Handle dropdown clicks
  const dropdownItems = document.querySelectorAll('.menu-item--has-dropdown');
  dropdownItems.forEach(item => {
    const menuLink = item.querySelector('.menu-link');

    menuLink.addEventListener('click', function(e) {
      // Prevent default navigation for dropdown parent links
      e.preventDefault();

      const isCurrentlyActive = item.classList.contains('active');

      // Close all other dropdowns
      dropdownItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove('active');
        }
      });

      // Toggle current dropdown
      if (isCurrentlyActive) {
        item.classList.remove('active');
      } else {
        item.classList.add('active');
      }
    });
  });

  // Close menu when clicking a dropdown link
  const dropdownLinks = menu.querySelectorAll('.dropdown-link');
  dropdownLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // Close menu when clicking a direct link (not dropdown parent)
  const directLinks = menu.querySelectorAll('a:not(.menu-link):not(.dropdown-link):not(.button)');
  directLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // Close dropdowns when clicking outside on desktop
  document.addEventListener('click', function(e) {
    if (window.innerWidth > 880) {
      const isClickInsideDropdown = e.target.closest('.menu-item--has-dropdown');
      if (!isClickInsideDropdown) {
        dropdownItems.forEach(item => {
          item.classList.remove('active');
        });
      }
    }
  });

  // Make header fixed on scroll
  let headerHeight = header.offsetHeight;

  window.addEventListener('scroll', function() {
    // Update header height in case it changes
    headerHeight = header.offsetHeight;

    if (window.scrollY > 50) {
      if (!header.classList.contains('fixed')) {
        header.classList.add('fixed');
        spacer.style.display = 'block';
        spacer.style.height = headerHeight + 'px';
      }
    } else {
      if (header.classList.contains('fixed')) {
        header.classList.remove('fixed');
        spacer.style.display = 'none';
        spacer.style.height = '0';
      }
    }

    // Close all dropdowns when scrolling on desktop
    if (window.innerWidth > 880) {
      dropdownItems.forEach(item => {
        item.classList.remove('active');
      });
    }
  });

  // Handle window resize
  window.addEventListener('resize', function() {
    // Close menu if screen becomes larger
    if (window.innerWidth > 880 && menu.classList.contains('active')) {
      closeMenu();
    }

    // Recalculate header height and update spacer
    if (header.classList.contains('fixed')) {
      headerHeight = header.offsetHeight;
      spacer.style.height = headerHeight + 'px';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  // Password modal functionality
  document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('password-modal');
    const openButton = document.getElementById('open-password-modal');
    const closeButton = document.getElementById('close-password-modal');
    const overlay = document.getElementById('password-modal-overlay');
    const passwordInput = document.getElementById('password-modal-input');

    function openModal(e) {
      e.preventDefault();
      modal.classList.add('password-modal--active');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        if (passwordInput) {
          passwordInput.focus();
        }
      }, 100);
    }

    function closeModal() {
      modal.classList.remove('password-modal--active');
      document.body.style.overflow = '';
    }

    if (openButton) {
      openButton.addEventListener('click', openModal);
    }

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('password-modal--active')) {
        closeModal();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
class ProductSlider {
  constructor(section) {
    this.section = section;
    this.wrapper = section.querySelector('.product-slider-wrapper');
    this.track = section.querySelector('.product-slider-track');
    this.slides = Array.from(section.querySelectorAll('.product-slide'));
    this.sizeBadges = Array.from(section.querySelectorAll('.size-badge'));
    this.prevButton = section.querySelector('.slider-arrow--prev');
    this.nextButton = section.querySelector('.slider-arrow--next');
    this.progressBar = section.querySelector('.slider-progress-bar');

    // Find the initial active slide index
    const activeSlide = this.slides.findIndex(slide => slide.classList.contains('product-slide--active'));
    this.currentIndex = activeSlide !== -1 ? activeSlide : 0;

    this.init();
  }

  init() {
    if (this.slides.length === 0) return;

    // Navigation arrows
    this.prevButton?.addEventListener('click', () => this.prev());
    this.nextButton?.addEventListener('click', () => this.next());

    // Size badges
    this.sizeBadges.forEach((badge, index) => {
      badge.addEventListener('click', () => this.goToSlide(index));
    });

    // Keyboard navigation
    this.section.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    });

    // Update progress bar with initial value
    this.updateProgressBar();
  }

  goToSlide(index) {
    if (index < 0 || index >= this.slides.length) return;

    // Remove active class from current slide and badge
    this.slides[this.currentIndex]?.classList.remove('product-slide--active');
    this.sizeBadges[this.currentIndex]?.classList.remove('size-badge--active');

    // Set new index
    this.currentIndex = index;

    // Add active class to new slide and badge
    this.slides[this.currentIndex]?.classList.add('product-slide--active');
    this.sizeBadges[this.currentIndex]?.classList.add('size-badge--active');

    // Update progress bar
    this.updateProgressBar();
  }

  next() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.goToSlide(nextIndex);
  }

  prev() {
    const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.goToSlide(prevIndex);
  }

  updateProgressBar() {
    if (!this.progressBar) return;
    const progress = ((this.currentIndex + 1) / this.slides.length) * 100;
    this.progressBar.style.width = `${progress}%`;
  }
}

// Initialize all product sliders on the page
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-slider-section').forEach(section => {
    new ProductSlider(section);
  });
});

// Shopify section editor support
if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.product-slider-section');
    if (section) new ProductSlider(section);
  });
}

  } catch(e) { console.error(e); }
})();
})();
